// import React, { useState, useEffect } from 'react';
// import cloudComputingBanner from '../img/aaaservices/fullstack.png';

// const AdvertisementShow = () => {
//   const [ads, setAds] = useState([
//     {
//       name: "Job Ad 1",
//       image: cloudComputingBanner, // Example image URL
//     },
//     {
//       name: "Job Ad 2",
//       image: cloudComputingBanner, // Example image URL
//     },
//     {
//       name: "Job Ad 3",
//       image: cloudComputingBanner, // Example image URL
//     },
//   ]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [isPaused, setIsPaused] = useState(false);

//   // Function to toggle animation pause/play
//   const toggleAnimation = () => {
//     setIsPaused(!isPaused); // Toggle animation state
//   };

//   // If you want to simulate loading, you can use this effect
//   useEffect(() => {
//     setLoading(true);
//     setTimeout(() => {
//       setLoading(false);
//     }, 1000); // Simulate 1-second loading
//   }, []);

//   if (loading) {
//     return <div className="ad-container">Loading...</div>;
//   }

//   if (error) {
//     return <div className="ad-container">Error: {error}</div>;
//   }

//   return (
//     <div className="ad-container" onClick={toggleAnimation}>
//       <div
//         className="ad-content"
//         style={{ animationPlayState: isPaused ? 'paused' : 'running' }}
//       >
//         {ads.map((ad, index) => (
//           <div key={index} className="ad-item">
//             {ad.image ? (
//               <img
//                 src={ad.image}
//                 alt={ad.name}
//                 className="ad-image"
//               />
//             ) : (
//               <div className="ad-placeholder">No Image</div>
//             )}
//             <div className="ad-name">{ad.name || `Advertisement ${index + 1}`}</div>
//           </div>
//         ))}
//         <style>
//           {`
//             .ad-container {
//               position: fixed;
//               right: -75px;
//               top: 100px;
//               bottom: 10px;
//               width: 25vw; /* Use a dynamic width based on the viewport */
//               max-width: 384px; /* Maximum width for larger screens */
//               min-width: 150px; /* Minimum width to ensure ads are still visible on very small screens */
//               overflow: hidden;
//               z-index:-1;
             
            
//               transition: width 0.5s ease; /* Smooth transition for resizing */
//             }

//             .ad-content {
//               display: flex;
//               flex-direction: column;
//               animation: scrollUp 15s linear infinite;
//               position: absolute;
//               bottom: 0; /* Start from the bottom */
//               width: 100%; /* Ensure the content fills the container */
//             }

//             .ad-item {
//               padding: 20px;
//               margin-left: 50px;
//               color: white;
//               margin: 5px 0;
//               margin-right: 100px;
//               background-color: #1367c8;
//               text-align: center;
//             }

//             .ad-image {
//               max-width: 100%;
//               height: auto;
//               border-radius: 4px;
//               margin-bottom: 10px;
//             }

//             .ad-placeholder {
//               width: 100%;
//               height: 150px;
//               background-color: #ccc;
//               display: flex;
//               align-items: center;
//               justify-content: center;
//               border-radius: 4px;
//               font-size: 14px;
//               color: #555;
//             }

//             .ad-name {
//               font-size: 16px;
//               font-weight: bold;
//               color: #fff;
//               margin-top: 10px;
//             }

//             /* Keyframes for scrolling up */
//             @keyframes scrollUp {
//               0% {
//                 transform: translateY(100%);
//               }
//               100% {
//                 transform: translateY(-10%);
//               }
//             }

//             /* Media Queries for responsiveness */
//             @media (max-width: 1200px) {
//               .ad-container {
//                 width: 30vw; /* Adjust for medium screens */
//               }
//             }

//             @media (max-width: 992px) {
//               .ad-container {
//                 width: 35vw; /* Adjust for smaller screens */
//               }
//             }

//             @media (max-width: 768px) {
//               .ad-container {
//                 width: 40vw; /* Further adjust for mobile screens */
//               }
//             }

//             @media (max-width: 480px) {
//               .ad-container {
//                 width: 50vw; /* Max width for very small screens */
//               }
//             }
//           `}
//         </style>
//       </div>
//     </div>
//   );
// };

// export default AdvertisementShow;





import React, { useState, useEffect } from 'react';
import cloudComputingBanner from '../img/aaaservices/robotic-program.jpg';
import cloudComputingBanner1 from '../img/aaaservices/pyt.webp';
import cloudComputingBanner2 from '../img/aaaservices/java-full-stack.webp';

import mechImg from '../Component/vr-picture1.jpg';
import simImg from '../Component/tool-and-die-maker-6.jpg';
import itImg from '../img/aaaservices/java-full-stack.webp';
import itImg1 from '../img/aaaservices/python3.webp';
import itImg2 from '../img/aaaservices/app-development-banner_33099-1720.avif';
import dfsImg from '../img/aaaservices/smart-factory-blog-image-1.webp';
import dfsImg1 from '../img/aaaservices/Thumbnail-Skill-Based-Professions-1.png';
import dfsImg2 from '../img/aaaservices/s.png';
import dfsImg3 from '../img/aaaservices/d.webp';

const AdvertisementShow = () => {
  const [ads, setAds] = useState([
    {
      name: "Launch Your Full Stack Career",
      image:  mechImg,
    },
    {
      name: "Explore Python Program",
      image: cloudComputingBanner1,
    },
    {
      name: "java-full-stack",
      image: cloudComputingBanner2,
    },
    {
      name: "Explore Cloud Solutions",
      image: simImg,
    },
    {
      name: "Explore Cloud Solutions",
      image: dfsImg,
    },
    {
      name: "Explore Cloud Solutions",
      image: dfsImg3,
    },
  ]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isPaused, setIsPaused] = useState(false);

  const toggleAnimation = () => {
    setIsPaused(!isPaused);
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  if (loading) return <div className="ad-container">Loading...</div>;
  if (error) return <div className="ad-container">Error: {error}</div>;

  return (
    <div className="ad-container" onClick={toggleAnimation}>
      <div
        className="ad-content"
        style={{ animationPlayState: isPaused ? 'paused' : 'running' }}
      >
        {ads.map((ad, index) => (
          <div key={index} className="ad-card">
            <img src={ad.image} alt={ad.name} className="ad-img" />
            <div className="ad-overlay">
              <div className="ad-title">{ad.name}</div>
            </div>
          </div>
        ))}

        <style>{`
          .ad-container {
            position: releative;
            right: 20px;
            top: 171px;
            width: 14vw;
          
            max-width: 300px;
            min-width: 222px;
            overflow: hidden;
            z-index: 0;
          }


//           .ad-container {
//    position: releative;
//   right: 0px;
//   top: 171;
//   width: 60px;
//   max-width: 300px;
//   min-width: 160px;
 
//   overflow: hidden;
//   z-index: 0; /* or 1 if needed */
// }

          .ad-content {
            display: flex;
            flex-direction: column;
            animation: scrollUp 15s linear infinite;
            gap: 20px;
          }

          .ad-card {
            position: relative;
            overflow: hidden;
            border-radius: 10px;
            background-color: #004aad; /* Solid blue background */
            box-shadow: 0 4px 10px rgba(0,0,0,0.2);
            cursor: pointer;
            transition: transform 0.3s ease;
          }

          .ad-card:hover {
            transform: scale(1.02);
          }

          .ad-img {
            width: 100%;
            height: auto;
            display: block;
            object-fit: cover;
            opacity: 0.9;
          }

          .ad-overlay {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            padding: 12px;
            background: linear-gradient(to top, rgba(0, 0, 0, 0.6), transparent);
            color: white;
            font-size: 1rem;
            font-weight: bold;
          }

          .ad-title {
            padding: 4px 6px;
          }

          @keyframes scrollUp {
            0% {
              transform: translateY(100%);
            }
            100% {
              transform: translateY(-100%);
            }
          }
@media (max-width: 768px) {
  .ad-container {
    width: 40vw;
    display: none;
  }
}


          @media (max-width: 480px) {
            .ad-container {
              width: 80vw;
              right: 5px;
             display: none;
            }

            .ad-title {
              font-size: 0.95rem;
            }
          }
        `}</style>
      </div>
    </div>
  );
};

export default AdvertisementShow;

